import React, { useRef, useState } from 'react';
import { Textarea, TextLabel, Stack, Button, Flex, Icon } from '@tonic-ui/react';
import styles from './copy-to-clipboard.module.css';

type CopyToClipBoardProps = {
  label?: string;
  value: string;
  resizableTextarea?: boolean;
  textareaRowsCount?: number;
  codeSample?: boolean;
  backgroundColor?: string;
};

const CopyToClipBoard = ({
  label,
  value,
  resizableTextarea,
  textareaRowsCount,
  codeSample,
  backgroundColor = 'transparent',
}: CopyToClipBoardProps) => {
  const textareaRef = useRef(null);
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopyToClipboard = async () => {
    const valueToCopy = textareaRef?.current?.value;
    try {
      await navigator.clipboard.writeText(valueToCopy);
      setCopySuccess(true);
      setTimeout(() => {
        setCopySuccess(false);
      }, 2000);
    } catch (error) {
      console.error('Copy to clipboard failed: ', error);
    }
  };

  return (
    <Stack spacing="1x">
      {label && (
        <TextLabel mb="2x" data-id="clipboard-label">
          {label}
        </TextLabel>
      )}

      <Stack direction="row" className={styles.wrapper} backgroundColor={backgroundColor}>
        <Textarea
          id="clipboard-text-area"
          data-id="clipboard-text-area"
          ref={textareaRef}
          variant="filled"
          readOnly
          className={`${styles.copyTextarea} ${codeSample ? styles.codeSample : ''}`}
          value={value}
          resize={resizableTextarea ? 'both' : 'none'}
          rows={textareaRowsCount ? textareaRowsCount : 0}
          backgroundColor={backgroundColor}
        />
        <Button
          data-id="clipboard-button"
          variant="ghost"
          width="40px"
          className={`${styles.copyButton} ${
            textareaRowsCount && textareaRowsCount === 1 ? styles.copyButtonOneRow : ''
          }`}
          alignSelf="flex-end"
          marginTop="0"
          onClick={handleCopyToClipboard}
        >
          <Flex justify="flex-start" align="center" data-id="clipboard-button-icon-wrapper">
            {!copySuccess && <Icon icon="file-copy-o" />}
            {copySuccess && <Icon icon="check" color="green:40" />}
          </Flex>
        </Button>
      </Stack>
    </Stack>
  );
};

export default CopyToClipBoard;
